module.exports = __webpack_public_path__ + "static/media/arturo@2x.e21500db.jpg";